import { getPath, getInitialState } from "../../utils";

const initialState = {
  activeCityProperty: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ACTIVE_CITY_PROPERTY":
      return setActiveCityProperty(state, action);
    case "RESET_STATE_CITY_PROPERTY":
      return resetState(state, action);
    default:
      return state;
  }
}

const setActiveCityProperty = (state, action) => {
  return {
    ...state,
    activeCityProperty: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
